import React, {useContext} from "react";
import Headroom from "react-headroom";
import "./Header.css";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import {
  greeting,
  workExperiences,
  skillsSection,
  openSource,
  blogSection,
  talkSection,
  achievementSection,
  educationInfo,
  researchinfo,
  studentOpportunities,
  teamSection,
  externalCollaborators,
  // ongoingProjects
} from "../../portfolio";

function Header() {
  const {isDark} = useContext(StyleContext);
  const viewExperience = workExperiences.display;
  const viewOpenSource = openSource.display;
  const viewSkills = skillsSection.display;
  const viewAchievement = achievementSection.display;
  const viewBlog = blogSection.display;
  const viewTalks = talkSection.display;
  const viewEducation = educationInfo.display;
  const viewProjects = achievementSection.display;
  const viewStudentOpportunities = studentOpportunities.display;
  const viewTeam = teamSection.display;
  const viewExternalCollaborators = externalCollaborators.display;
  // const viewOngoingProjects = ongoingProjects.display;
  const viewResearch = researchinfo.display;


  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <a href="/" className="logo">
          <span className="grey-color"> &lt;</span>
          {/* <span className="logo-name">{greeting.username}</span> */}
          <span className="grey-color">/&gt;</span>
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          {/* {viewSkills && (
            <li>
              <a href="#skills">Skills</a>
            </li>
          )} */}
          
          {viewEducation && (
            <li>
              <a href="#research">Research</a>
            </li>
          )}
          
          {viewProjects && (
            <li>
              <a href="#projects">Ongoing-Projects</a>
            </li>
          )}

          {viewStudentOpportunities && (
            <li>
              <a href="#student-opportunities">Opportunities to Join</a>
            </li>
          )}

          {viewTeam && (
            <li>
              <a href="#team">Team</a>
            </li>
          )}

          {viewExternalCollaborators && (
            <li>
              <a href="#external-collaborators">Collaborators</a>
            </li>
          )}
          
          <li>
            <a
              href="https://arena-lab.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit ARENA Lab
            </a>
          </li>
          
          {/* {viewTalks && (
            <li>
              <a href="#talks">Talks</a>
            </li>
          )} */}
          <li>
            <a href="#">
              <ToggleSwitch />
            </a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
